<template>
    <calculation-container>
        <calculation-steps/>
        <h2 class="calculator__header">Zadejte rozměry konstrukce</h2>
        <calculation-user-input/>
        <h2 class="calculator__header">Soupis materiálu pro vaši stavbu</h2>
        <calculation-construction v-if="construction"/>
    </calculation-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import CalculationContainer from '../../CalculationContainer';
import CalculationSteps from '../steps/Steps';
import CalculationConstruction from './Construction';
import CalculationUserInput from '../user-input/UserInput';
import calculationMixin from '../mixins/calculation.mixin';

export default {
    name:       'CalculationConstructionContainer',
    mixins:     [calculationMixin],
    components: {
        CalculationUserInput,
        CalculationConstruction,
        CalculationSteps,
        CalculationContainer
    },
    mounted() {
        const { projectSlug, constructionId } = this.$route.params;
        this.setProjectSlug(projectSlug);
        this.setConstructionId(constructionId);
        this.fetchConstruction()
        .then(() => this.remarketingDataLayer())
        .catch(() => this.$router.push({ name: 'calculation.projectSelect' }));
    },
    computed:   {
        ...mapGetters('calculation', ['construction', 'userInput'])
    },
    methods:    {
        ...mapActions('calculation', ['setProjectSlug', 'setConstructionId', 'fetchConstruction']),
        remarketingDataLayer() {
            dataLayer.push({
                'event':     'calculator_step_2',
                'step':      2,
                'section':   this.construction.id,
                'area':      this.userInput.meters,
                'waste':     this.userInput.cut,
                'ecommerce': {
                    'checkout': {
                        'actionField': { 'step': 2, 'option': this.construction.name }
                    }
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/construction/ConstructionContainer.vue